import { ExtractPropTypes } from 'vue'
import { buildProps } from '@sgui-plus/utils/props'

export const multiFilterProps = buildProps({
  data: {
    type: Array,
    default: () => []
  },
  defaultValue: {
    type: Array,
    default: () => []
  },
  titleWidth: {
    type: [Number, String],
    default: ''
  },
  size: {
    type: String,
    values: ['large', 'default', 'small'],
    default: 'default'
  },
  checkAllEmpty: {
    type: Boolean,
    default: false
  },
  showSelection: {
    type: Boolean,
    default: false
  },
  props: {
    type: Object,
    default: () => ({
      title: 'title',
      option: 'option',
      label: 'label',
      value: 'value',
    })
  }
})

export const multiFilterEmits = {
  onChange: (value: any[]) => Array.isArray(value)
}

export type MultiFilterProps = ExtractPropTypes<typeof multiFilterProps>
export type MultiFilterEmits = typeof multiFilterEmits
